export const SETUP_STEP_CONFIG = {
	compliance: { tab: 0, scrollId: 'email-setup-compliance' },
	'awaiting-approval': { tab: 0, scrollId: 'email-setup-awaiting-approval' },
	domain: {
		tab: 1,
		scrollId: 'email-setup-domain',
		openAction: 'add-domain',
	},
	'add-domain': {
		tab: 1,
		scrollId: 'email-setup-domain',
		openAction: 'add-domain',
	},
	'verify-domain': { tab: 1, scrollId: 'email-setup-domain' },
	'add-sender': {
		tab: 2,
		scrollId: 'email-setup-sender',
		openAction: 'add-sender',
	},
	// Legacy deep links from older 5-step checklist
	'email-service': { tab: 0, scrollId: 'email-setup-compliance' },
};

export const emailSetupStepUrl = (stepId) =>
	`/settings?section=domains&setupStep=${stepId}`;
